import PersonalDetails from "./personalDetails";

export { PersonalDetails };
export default PersonalDetails;
